// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from "react-router-dom";
// import axios from 'axios';

// const UpdateOtherSettings = () => {
//   const { pubId } = useParams(); // Get pubId from URL
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState(null);

//   const [loading, setLoading] = useState(false);
// //   const [fetching, setFetching] = useState(true);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   // Fetch existing data on mount
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getOtherSettings/${pubId}`,
//             {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//         }
//     );
//     console.log(response.data.data[0]);
    
//         const data = response.data.data[0];
//         console.log(data);
        

//         // Set fetched data to form (ensure keys match)
//         setFormData({
//           account_id: data.account_id || pubId,
//           pwcta: data.pwcta || '',
//           pwicn: data.pwicn || '',
//           pwtxt: data.pwtxt || '',
//           pwbpos: data.pwbpos || 'bottom',
//           pwbt: data.pwbt || '',
//         });

//         setMessage('');
//       } catch (error) {
//         // console.error('Error fetching settings:', error);
//         // setMessage('Failed to load existing settings.');
//         setMessageType('danger');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [pubId]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/updateOtherSettings`, 
//         formData, 
//         {
//         headers: {             
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json", 
//         }
//       });

//       setMessage('Settings updated successfully!');
//       setMessageType('success');
//       alert("Settings updated successfully!")
//       navigate(-1);
//     } catch (error) {
//       console.error('Error updating settings:', error);
//       const errorMsg = error.response?.data?.message || 'Failed to update settings.';
//       setMessage(`Error: ${errorMsg}`);
//       setMessageType('danger');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4" style={{ maxWidth: '600px' }}>
//       <h3>Update Other Settings</h3>
//         {
//             message && (
//                 <div className={`alert mt-3 alert-${messageType}`} role="alert">
//                 {message}
//                 </div>
//             )
//         }
//       {!formData  ? (
//         <p>Loading existing settings...</p>
//       ) : (
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label htmlFor="account_id" className="form-label">Account ID</label>
//             <input
//               type="text"
//               className="form-control"
//               id="account_id"
//               name="account_id"
//               value={formData.account_id}
//               onChange={handleChange}
//               readOnly
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="pwcta" className="form-label">Powered by CTA (URL)</label>
//             <input
//               type="text"
//               className="form-control"
//               id="pwcta"
//               name="pwcta"
//               value={formData.pwcta}
//               onChange={handleChange}
              
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="pwicn" className="form-label">Powered by Icon</label>
//             <input
//               type="text"
//               className="form-control"
//               id="pwicn"
//               name="pwicn"
//               value={formData.pwicn}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="pwtxt" className="form-label">Powered by Text</label>
//             <input
//               type="text"
//               className="form-control"
//               id="pwtxt"
//               name="pwtxt"
//               value={formData.pwtxt}
//               onChange={handleChange}
              
//             />
//           </div>

//           <div className="mb-3">
//             <label htmlFor="pwbpos" className="form-label">Powered by Position</label>
//             <select
//               className="form-select"
//               id="pwbpos"
//               name="pwbpos"
//               value={formData.pwbpos}
//               onChange={handleChange}
              
//             >
//               <option value="bottom">Bottom</option>
//               <option value="top">Top</option>
//             </select>
//           </div>

//           <div className="mb-3">
//             <label htmlFor="pwbt" className="form-label">Powered by Timer</label>
//             <input
//               type="text"
//               className="form-control"
//               id="pwbt"
//               name="pwbt"
//               value={formData.pwbt}
//               onChange={handleChange}
//             />
//           </div>

//           <button type="submit" className="btn btn-primary" disabled={loading}>
//             {loading ? 'Updating...' : 'Update Settings'}
//           </button>

//           <button type="button" className="btn btn-secondary mx-3" onClick={()=>navigate(-1)}>
//             Cancel
//           </button>

//         </form>
//       )}
//     </div>
//   );
// };

// export default UpdateOtherSettings;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./otherSetting.css";

const UpdateOtherSettings = () => {
  const { pubId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Fetch existing settings
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/getOtherSettings/${pubId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const data = response.data.data[0];

        setFormData({
          account_id: data.account_id || pubId,
          pwcta: data.pwcta || "",
          pwicn: data.pwicn || "",
          pwtxt: data.pwtxt || "",
          pwbpos: data.pwbpos || "bottom",
          pwbt: data.pwbt || "",
        });

        setMessage("");
      } catch (error) {
        console.error("Error fetching settings:", error);

        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/");
          return;
        }

        setMessage("Failed to load existing settings.");
        setMessageType("danger");
      }
    };

    fetchData();
  }, [pubId, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/updateOtherSettings`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      setMessage("Settings updated successfully!");
      setMessageType("success");

      setTimeout(() => {
        navigate(-1);
      }, 1200);
    } catch (error) {
      console.error("Error updating settings:", error);

      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
        return;
      }

      const errorMsg =
        error.response?.data?.message ||
        "Failed to update settings.";

      setMessage(errorMsg);
      setMessageType("danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mainContainer otherSettingsPage">
      <div className="otherSettingsContainer">

        {/* Page Header */}
        <div className="otherSettingsHeader">
          <div>
            <h2>Update Other Settings</h2>
            <p>
              Manage the publisher's powered-by settings and display preferences.
            </p>
          </div>
        </div>

        {/* Message */}
        {message && (
          <div
            className={`alert alert-${messageType} otherSettingsAlert`}
            role="alert"
          >
            {message}
          </div>
        )}

        {/* Loading */}
        {!formData ? (
          <div className="settingsLoading">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>

            <p>Loading existing settings...</p>
          </div>
        ) : (
          <div className="settingsCard">

            <form onSubmit={handleSubmit}>

              {/* Account ID */}
              <div className="settingsFormGroup">
                <label htmlFor="account_id">
                  Account ID
                </label>

                <input
                  type="text"
                  className="form-control settingsInput settingsReadonly"
                  id="account_id"
                  name="account_id"
                  value={formData.account_id}
                  onChange={handleChange}
                  readOnly
                />

                <small className="settingsHelpText">
                  Account ID is automatically assigned and cannot be changed.
                </small>
              </div>

              {/* Powered by CTA */}
              <div className="settingsFormGroup">
                <label htmlFor="pwcta">
                  Powered by CTA <span>(URL)</span>
                </label>

                <input
                  type="text"
                  className="form-control settingsInput"
                  id="pwcta"
                  name="pwcta"
                  value={formData.pwcta}
                  onChange={handleChange}
                  placeholder="Enter CTA URL"
                />
              </div>

              {/* Powered by Icon */}
              <div className="settingsFormGroup">
                <label htmlFor="pwicn">
                  Powered by Icon
                </label>

                <input
                  type="text"
                  className="form-control settingsInput"
                  id="pwicn"
                  name="pwicn"
                  value={formData.pwicn}
                  onChange={handleChange}
                  placeholder="Enter icon URL"
                />
              </div>

              {/* Powered by Text */}
              <div className="settingsFormGroup">
                <label htmlFor="pwtxt">
                  Powered by Text
                </label>

                <input
                  type="text"
                  className="form-control settingsInput"
                  id="pwtxt"
                  name="pwtxt"
                  value={formData.pwtxt}
                  onChange={handleChange}
                  placeholder="Enter powered by text"
                />
              </div>

              {/* Powered by Position */}
              <div className="settingsFormGroup">
                <label htmlFor="pwbpos">
                  Powered by Position
                </label>

                <select
                  className="form-select settingsInput"
                  id="pwbpos"
                  name="pwbpos"
                  value={formData.pwbpos}
                  onChange={handleChange}
                >
                  <option value="bottom">Bottom</option>
                  <option value="top">Top</option>
                </select>
              </div>

              {/* Powered by Timer */}
              <div className="settingsFormGroup">
                <label htmlFor="pwbt">
                  Powered by Timer
                </label>

                <input
                  type="text"
                  className="form-control settingsInput"
                  id="pwbt"
                  name="pwbt"
                  value={formData.pwbt}
                  onChange={handleChange}
                  placeholder="Enter timer value"
                />
              </div>

              {/* Buttons */}
              <div className="settingsActions">

                <button
                  type="submit"
                  className="btn settingsUpdateBtn"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Updating...
                    </>
                  ) : (
                    "Update Settings"
                  )}
                </button>

                <button
                  type="button"
                  className="btn settingsCancelBtn"
                  onClick={() => navigate(-1)}
                  disabled={loading}
                >
                  Cancel
                </button>

              </div>

            </form>
          </div>
        )}
      </div>
    </section>
  );
};

export default UpdateOtherSettings;